<template>
  <div>
    <ValidationObserver ref="observer" style="position: absolute">
      <modal-cadu close :width="1131.52" v-model="valueData">
        <div slot="all" class="py-10 px-10">
          <div slot="header" class="primary1--text headline font-weight-bold">
            {{ mode === 'view' ? 'VISUALIZAR' : 'EDITAR' }} QUANTIDADE DE BENEFICIÁRIOS
          </div>
          <div slot="body">
            <v-row align="center" v-if="!isCompetenciaAntiga">
              <v-col cols="2" v-if="mode == 'view'"> </v-col>
              <v-col cols="2">
                <validation-provider name="competencia" mode="eager" v-slot="{ errors }">
                  <input-cadu
                    :errorMessage="errors[0]"
                    title="Competência"
                    v-model="objetoBeneficiario.competencia"
                    icon="calendar"
                    v-mask="'##/####'"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    disabled
                  />
                </validation-provider>
              </v-col>
              <v-col cols="2">
                <validation-provider name="dataAtualizacao" mode="eager" v-slot="{ errors }">
                  <input-cadu
                    :errorMessage="errors[0]"
                    title="Última Atualização"
                    v-model="objetoBeneficiario.dataAtualizacao"
                    icon="calendar"
                    v-mask="'##/##/####'"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    disabled
                  />
                </validation-provider>
              </v-col>
              <v-col cols="2">
                <input-cadu
                  title="Fonte"
                  v-model="fonteAtualizacao"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  disabled
                />
              </v-col>
              <v-col cols="2">
                <validation-provider name="tipoAtualizacao" mode="eager" v-slot="{ errors }">
                  <input-cadu
                    :errorMessage="errors[0]"
                    title="Tipo de Atualização"
                    v-model="objetoBeneficiario.tipoAtualizacao"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    disabled
                  />
                </validation-provider>
              </v-col>
              <v-col cols="3" v-if="mode !== 'view' && !disabledFields" style="margin-top: 20px">
                <button-cadu
                  :width="220"
                  iconName="upload-cloud"
                  :iconSize="18"
                  text="ATUALIZAR CADBENEF"
                  class="btnUpdateCadBenef"
                  :loading="loadingCadBenef"
                  @click="consultarCadbenef()"
                />
              </v-col>
            </v-row>

            <!-- Competencias antigas -->
            <v-row align="center" v-if="isCompetenciaAntiga">
              <v-col cols="2"></v-col>
              <v-col cols="3">
                <validation-provider name="competencia" mode="eager" v-slot="{ errors }">
                  <input-cadu
                    :errorMessage="errors[0]"
                    title="Competência"
                    v-model="objetoBeneficiario.competencia"
                    icon="calendar"
                    v-mask="'##/####'"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    disabled
                  />
                </validation-provider>
              </v-col>
              <v-col cols="3">
                <validation-provider name="dataAtualizacao" mode="eager" v-slot="{ errors }">
                  <input-cadu
                    :errorMessage="errors[0]"
                    title="Última Atualização"
                    v-model="objetoBeneficiario.dataAtualizacao"
                    icon="calendar"
                    v-mask="'##/##/####'"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    disabled
                  />
                </validation-provider>
              </v-col>
              <v-col cols="2">
                <validation-provider name="tipoAtualizacao" mode="eager" v-slot="{ errors }">
                  <input-cadu
                    :errorMessage="errors[0]"
                    title="Tipo de Atualização"
                    v-model="objetoBeneficiario.tipoAtualizacao"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    disabled
                  />
                </validation-provider>
              </v-col>
              <v-col cols="2"></v-col>
            </v-row>

            <v-row style="position: relative">
              <v-col cols="2" style="padding-top: 40px" class="font13" v-if="isCompetenciaAntiga">PESSOA FISÍCA</v-col>
              <v-col cols="2" style="padding-top: 40px" class="font13" v-if="!isCompetenciaAntiga"
                >INDIVIDUAL OU FAMILIAR</v-col
              >
              <v-col cols="4">
                <validation-provider
                  name="qtPessoaFisicaCustoOperacional"
                  rules="required|max:7"
                  mode="eager"
                  v-slot="{ errors }"
                >
                  <input-cadu
                    :mask="[
                      '####',
                      '#.###',
                      '##.###',
                      '###.###',
                      '####.###',
                      '#.###.###',
                      '##.###.###',
                      '###.###.###',
                      '#.###.###.##'
                    ]"
                    :errorMessage="errors[0]"
                    title="Custo Operacional / Pós Pagamento"
                    v-model="objetoBeneficiario.qtPessoaFisicaCustoOperacional"
                    onlyNumber
                    textAlign="end"
                    :colorText="'#00995d'"
                    :disabled="mode === 'view' || disabledFields"
                  />
                </validation-provider>
              </v-col>
              <div style="position: absolute; left: 48%; top: 10%; white-space: pre-line">
                <tooltip-help
                  width="400"
                  style=""
                  text="Contrato que têm o valor da contraprestação pecuniária calculado após a realização das despesas com as coberturas contratadas, podendo ser utilizado nas opções de Rateio ou Custo Operacional."
                />
              </div>
              <v-col cols="4">
                <validation-provider
                  name="qtPessoaFisicaPrePagamento"
                  rules="required|max:7"
                  mode="eager"
                  v-slot="{ errors }"
                >
                  <input-cadu
                    :mask="[
                      '####',
                      '#.###',
                      '##.###',
                      '###.###',
                      '####.###',
                      '#.###.###',
                      '##.###.###',
                      '###.###.###',
                      '#.###.###.##'
                    ]"
                    :errorMessage="errors[0]"
                    title="Pré Pagamento / Pré-estabelecido"
                    v-model="objetoBeneficiario.qtPessoaFisicaPrePagamento"
                    onlyNumber
                    textAlign="end"
                    :colorText="'#00995d'"
                    :disabled="mode === 'view' || disabledFields"
                  />
                </validation-provider>
              </v-col>
              <div style="position: absolute; left: 80%; top: 10%">
                <tooltip-help
                  width="400"
                  text="Contrato que têm o valor da contraprestação pecuniária calculado antes da utilização das coberturas contratadas."
                />
              </div>
            </v-row>
            <v-row>
              <v-col cols="2" style="padding-top: 20px" class="font13" v-if="!isCompetenciaAntiga"
                >COLETIVO EMPRESARIAL</v-col
              >
              <v-col cols="2" style="padding-top: 20px" class="font13" v-if="isCompetenciaAntiga"
                >PESSOA JURÍDICA</v-col
              >
              <v-col cols="4">
                <validation-provider
                  name="qtPessoaJuridicaCustoOperacional"
                  rules="required|max:7"
                  mode="eager"
                  v-slot="{ errors }"
                >
                  <input-cadu
                    :mask="[
                      '####',
                      '#.###',
                      '##.###',
                      '###.###',
                      '####.###',
                      '#.###.###',
                      '##.###.###',
                      '###.###.###',
                      '#.###.###.##'
                    ]"
                    :errorMessage="errors[0]"
                    v-model="objetoBeneficiario.qtPessoaJuridicaCustoOperacional"
                    onlyNumber
                    textAlign="end"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    :disabled="mode === 'view' || disabledFields"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="4">
                <validation-provider
                  name="qtPessoaJuridicaPrePagamento"
                  rules="required|max:7"
                  mode="eager"
                  v-slot="{ errors }"
                >
                  <input-cadu
                    :mask="[
                      '####',
                      '#.###',
                      '##.###',
                      '###.###',
                      '####.###',
                      '#.###.###',
                      '##.###.###',
                      '###.###.###',
                      '#.###.###.##'
                    ]"
                    :errorMessage="errors[0]"
                    v-model="objetoBeneficiario.qtPessoaJuridicaPrePagamento"
                    onlyNumber
                    textAlign="end"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    :disabled="mode === 'view' || disabledFields"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row v-if="!isCompetenciaAntiga">
              <v-col style="padding-top: 20px" cols="2" class="font13">COLETIVO POR ADESÃO</v-col>
              <v-col cols="4">
                <validation-provider
                  name="qtPessoaJuridicaAdesaoCustoOperacional"
                  rules="required|max:7"
                  mode="eager"
                  v-slot="{ errors }"
                >
                  <input-cadu
                    :mask="[
                      '####',
                      '#.###',
                      '##.###',
                      '###.###',
                      '####.###',
                      '#.###.###',
                      '##.###.###',
                      '###.###.###',
                      '#.###.###.##'
                    ]"
                    :errorMessage="errors[0]"
                    v-model="objetoBeneficiario.qtPessoaJuridicaAdesaoCustoOperacional"
                    onlyNumber
                    textAlign="end"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    :disabled="mode === 'view' || disabledFields"
                  />
                </validation-provider>
              </v-col>
              <v-col cols="4">
                <validation-provider
                  name="qtPessoaJuridicaAdesaoPrePagamento"
                  rules="required|max:7"
                  mode="eager"
                  v-slot="{ errors }"
                >
                  <input-cadu
                    :mask="[
                      '####',
                      '#.###',
                      '##.###',
                      '###.###',
                      '####.###',
                      '#.###.###',
                      '##.###.###',
                      '###.###.###',
                      '#.###.###.##'
                    ]"
                    :errorMessage="errors[0]"
                    v-model="objetoBeneficiario.qtPessoaJuridicaAdesaoPrePagamento"
                    onlyNumber
                    textAlign="end"
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    :disabled="mode === 'view' || disabledFields"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2"></v-col>
              <v-col cols="4">
                <div class="font-weight" style="text-align: end" v-if="!isCompetenciaAntiga">
                  Total de Beneficiários Unimed:
                </div>
                <div class="font-weight" style="text-align: end" v-if="isCompetenciaAntiga">
                  Total de Beneficiários:
                </div>
              </v-col>
              <v-col cols="4">
                <input-cadu
                  :value="totalBeneficiario"
                  :mask="[
                    '####',
                    '#.###',
                    '##.###',
                    '###.###',
                    '####.###',
                    '#.###.###',
                    '##.###.###',
                    '###.###.###',
                    '#.###.###.##'
                  ]"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  disabled
                  textAlign="end"
                  colorBgField="#333"
                  colorInput="white"
                />
              </v-col>
            </v-row>
            <v-row v-if="!isCompetenciaAntiga">
              <v-col cols="2"></v-col>
              <v-col cols="4">
                <div class="font-weight-bold font13" style="text-align: right">
                  Total de Beneficiários AutoGestão (Cessão de Rede):
                </div>
              </v-col>
              <v-col cols="4">
                <input-cadu
                  v-if="disabledFields"
                  :value="objetoBeneficiario.qtAutoGestao"
                  :mask="[
                    '####',
                    '#.###',
                    '##.###',
                    '###.###',
                    '####.###',
                    '#.###.###',
                    '##.###.###',
                    '###.###.###',
                    '#.###.###.##'
                  ]"
                  onlyNumber
                  colorBgField="#333"
                  colorInput="white"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  textAlign="end"
                  :disabled="mode === 'view' || disabledFields"
                />

                <validation-provider rules="required" mode="eager" v-slot="{ errors }">
                  <input-cadu
                    v-if="!disabledFields"
                    :errorMessage="errors[0]"
                    v-model="objetoBeneficiario.qtAutoGestao"
                    :mask="[
                      '####',
                      '#.###',
                      '##.###',
                      '###.###',
                      '####.###',
                      '#.###.###',
                      '##.###.###',
                      '###.###.###',
                      '#.###.###.##'
                    ]"
                    onlyNumber
                    :colorText="$vuetify.theme.themes.light.fontColor1"
                    textAlign="end"
                    :disabled="mode === 'view' || disabledFields"
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </div>

          <div slot="footer">
            <div v-if="mode === 'view'">
              <v-row align="end" justify="end">
                <v-col cols="auto">
                  <button-cadu
                    @click="$emit('input', false)"
                    :backColor="$vuetify.theme.themes.light.primary2"
                    text="VOLTAR"
                  />
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <v-row align="start" justify="start">
                <v-col cols="auto">
                  <button-cadu outline @click="verificarMudanca"> CANCELAR </button-cadu>
                </v-col>
                <v-row align="end" justify="end" class="mr-2">
                  <v-col cols="auto">
                    <button-cadu :backColor="$vuetify.theme.themes.light.primary2" class="px-4" @click="clean">
                      LIMPAR
                    </button-cadu>
                  </v-col>
                  <v-col cols="auto">
                    <button-cadu @click="putBeneficiario"> SALVAR </button-cadu>
                  </v-col>
                </v-row>
              </v-row>
            </div>
          </div>
        </div>
      </modal-cadu>
    </ValidationObserver>
    <overlay-loading :value="loadingOverlay" />
    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao" />
    <SucessoModal
      :showSucess="showSuccessCadbenef"
      :genericMessage="genericMessage"
      :width="560"
      @close="resetSuccessCadbenef"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Beneficiario from '@/services/Perfil/Beneficiario'
import { mask } from 'vue-the-mask'
import { cloneDeep, isEqual } from 'lodash'
import { EventBus } from '@/services/EventBus/EventBus'
import BeneficiarioCadbenefService from '@/services/BeneficiarioCadbenefService'

export default {
  directives: {
    mask
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      valueData: this.value,
      competencia: '08/2018',
      dataAtualizacao: '01/07/2018',
      tipoAtualizacao: 'Manual',
      fonteAtualizacao: 'UNIMED',
      qtPessoaFisicaCustoOperacional: -1,
      qtPessoaFisicaPrePagamento: -1,
      qtPessoaJuridicaCustoOperacional: -1,
      qtPessoaJuridicaPrePagamento: -1,
      atualizacao: false,
      id: -1,
      loadingOverlay: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      totalBeneficionario: -1,
      showModalCancelar: false,
      loadingCadBenef: false,
      showButtonAtualizarCadBenef: false,
      isCompetenciaAntiga: false,
      disabledFields: true,
      showSuccessCadbenef: false,
      genericMessage: `Quantidade de beneficiários atualizada com sucesso!`,
      cloneObjetoBeneficiario: {
        competencia: '',
        dataAtualizacao: '',
        atualizacaoOnline: '',
        tipoAtualizacao: '',
        qtPessoaFisicaCustoOperacional: '',
        qtPessoaFisicaPrePagamento: '',
        qtPessoaJuridicaCustoOperacional: '',
        qtPessoaJuridicaPrePagamento: '',
        qtPessoaJuridicaAdesaoCustoOperacional: '',
        qtPessoaJuridicaAdesaoPrePagamento: '',
        qtAutoGestao: '',
        fonteAtualizacao: 'UNIMED',
        id: -1
      },
      objetoBeneficiario: {
        competencia: '',
        dataAtualizacao: '',
        atualizacaoOnline: '',
        tipoAtualizacao: '',
        qtPessoaFisicaCustoOperacional: '',
        qtPessoaFisicaPrePagamento: '',
        qtPessoaJuridicaCustoOperacional: '',
        qtPessoaJuridicaPrePagamento: '',
        id: -1,
        qtPessoaJuridicaAdesaoCustoOperacional: '0',
        qtPessoaJuridicaAdesaoPrePagamento: '0',
        qtAutoGestao: '0',
        fonteAtualizacao: 'UNIMED'
      },
      cloneBeneficiario: {}
    }
  },
  beforeMount() {},
  methods: {
    clean() {
      this.objetoBeneficiario.qtPessoaFisicaCustoOperacional = 0
      this.objetoBeneficiario.qtPessoaFisicaPrePagamento = 0
      this.objetoBeneficiario.qtPessoaJuridicaCustoOperacional = 0
      this.objetoBeneficiario.qtPessoaJuridicaPrePagamento = 0
    },
    start(row) {
      this.competencia = row.competencia
      this.objetoBeneficiario.competencia = row.competencia
      this.objetoBeneficiario.dataAtualizacao = row.dataAtualizacao
      this.objetoBeneficiario.atualizacaoOnline = row.atualizacaoOnline
      this.objetoBeneficiario.tipoAtualizacao = row.tipoAtualizacao
      this.objetoBeneficiario.qtPessoaFisicaCustoOperacional = row.qtPessoaFisicaCustoOperacional.toString()
      this.objetoBeneficiario.qtPessoaFisicaPrePagamento = row.qtPessoaFisicaPrePagamento.toString()
      this.objetoBeneficiario.qtPessoaJuridicaCustoOperacional = row.qtPessoaJuridicaCustoOperacional.toString()
      this.objetoBeneficiario.qtPessoaJuridicaPrePagamento = row.qtPessoaJuridicaPrePagamento.toString()
      this.objetoBeneficiario.id = row.id
      this.objetoBeneficiario.qtPessoaJuridicaAdesaoCustoOperacional =
        row.qtPessoaJuridicaAdesaoCustoOperacional * 1 || 0
      this.objetoBeneficiario.qtPessoaJuridicaAdesaoPrePagamento = row.qtPessoaJuridicaAdesaoPrePagamento * 1 || 0
      this.objetoBeneficiario.qtAutoGestao = row.qtAutoGestao * 1 || 0

      this.objetoBeneficiario.fonteAtualizacao = row.fonteAtualizacao
      this.fonteAtualizacao = row.fonteAtualizacao
      this.cloneObjetoBeneficiario = cloneDeep(this.objetoBeneficiario)

      this.podeAtualizarCadbenef()
    },
    async atualizarCadBenef(reenviarComErro = false) {
      this.loadingOverlay = true
      this.loadingCadBenef = true
      try {
        const beneficiarioService = new BeneficiarioCadbenefService(this.tokenBearer, this.$appConfig.config.API)
        await beneficiarioService.consultarCompetenciaBeneficiariosCadbenef(
          this.competencia,
          [this.$idUnimed],
          reenviarComErro
        )
        this.loadingCadBenef = false
        this.$emit('success')
      } catch (errors) {
        this.loadingCadBenef = false
        this.showError = true
        errors.origin = 'atualizacaoCadbenef'
        this.$emit('error', errors)
      }
      this.loadingOverlay = false
    },
    async consultarCadbenef(reenviarComErro = false) {
      this.loadingCadBenef = true
      const beneficiarioService = new BeneficiarioCadbenefService(this.tokenBearer, this.$appConfig.config.API)

      await beneficiarioService
        .consultarCompetenciaBeneficiariosCadbenef(this.competencia, [this.$idUnimed], reenviarComErro)
        .then((res) => {
          this.tratarResposta(this.$idUnimed, res.data)
          this.showSuccessCadbenef = true
        })
        .catch((err) => {
          this.showError = true
          err.origin = 'atualizacaoCadbenef'
          this.$emit('error', err)
        })
        .finally(() => {
          this.loadingCadBenef = false
          this.loadingOverlay = false
        })
    },
    async putBeneficiario(justificativa) {
      if (await this.$refs.observer.validate()) {
        let beneficiario = new Beneficiario(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

        this.loadingOverlay = true

        let data = {
          competencia: this.objetoBeneficiario.competencia,
          id: this.objetoBeneficiario.id,
          qtPessoaFisicaCustoOperacional: this.objetoBeneficiario.qtPessoaFisicaCustoOperacional,
          qtPessoaFisicaPrePagamento: this.objetoBeneficiario.qtPessoaFisicaPrePagamento,
          qtPessoaJuridicaCustoOperacional: this.objetoBeneficiario.qtPessoaJuridicaCustoOperacional,
          qtPessoaJuridicaPrePagamento: this.objetoBeneficiario.qtPessoaJuridicaPrePagamento,
          qtPessoaJuridicaAdesaoCustoOperacional: this.objetoBeneficiario.qtPessoaJuridicaAdesaoCustoOperacional,
          qtPessoaJuridicaAdesaoPrePagamento: this.objetoBeneficiario.qtPessoaJuridicaAdesaoPrePagamento,
          qtAutoGestao: this.objetoBeneficiario.qtAutoGestao,
          tipoAtualizacao: 'MANUAL',
          fonteAtualizacao: 'UNIMED',
          justificativa,
          atualizacaoOnline: this.objetoBeneficiario.atualizacaoOnline
        }

        try {
          let response = await beneficiario.putBeneficiario(data)
          let mensagem = response.data.mensagem
          let gerouPendencia = response.data.gerouPendencia

          if (gerouPendencia) {
            EventBus.$emit('pendenteModal', { mensagem, gerouPendencia })
          } else {
            this.objetoBeneficiario.id = response.data.idCompetencia
            this.$emit('success', {
              origin: 'atualizacaoBeneficiarios',
              message: 'Informações de beneficiários salvas com sucesso!'
            })
          }
          EventBus.$emit('resolverAlertaNotificaoPendente', { tipoNotificacao: 'NUMERO_BENEFICIARIOS' })
        } catch (err) {
          this.$emit('error', err.response)
        }
        this.loadingOverlay = false
      }
    },
    verificarMudanca() {
      if (!isEqual(this.objetoBeneficiario, this.cloneObjetoBeneficiario)) {
        this.showModalCancelar = true
      } else {
        this.$emit('input', false)
      }
    },
    cancelarEdicao() {
      this.showModalCancelar = false
      this.start(this.cloneObjetoBeneficiario)
      this.$emit('input', false)
    },
    podeAtualizarCadbenef() {
      const competencia = this.convertCompetencia(this.competencia);
       // habilita os campos do formulario
       if (!this.editProp && this.role === 'admin_brasil') {
        this.disabledFields = false;
      } else {
        this.disabledFields = true;
      }

      // Ativa o butão de atualização de competência beneficiarios
      if (competencia > '2022-11') {
        this.isCompetenciaAntiga = false;
      } else {
        this.isCompetenciaAntiga = true;
      }

      if (!this.isCompetenciaAntiga && this.role === 'admin_brasil') {
        this.showButtonAtualizarCadBenef = true;
      }
    },
    convertCompetencia(text) {
      if (!text) {
        return text
      } else {
        let competencia = text.split('/')
        return `${competencia[1]}-${competencia[0]}`
      }
    },
    convertDate(text) {
      if (!text) {
        return text
      } else {
        let competencia = text.split('-')
        return `${competencia[2]}/${competencia[1]}/${competencia[0]}`
      }
    },
    resetSuccessCadbenef() {
      this.showSuccessCadbenef = false
      this.loadingCadBenef = false
    },
    tratarResposta(idUnimed, response) {
      if (!!response.unimeds && response.unimeds.length > 0 && response.unimeds[0].codigoUnimed == idUnimed) {
        let resultadoUnimed = response.unimeds[0]
        let contratos = resultadoUnimed.tipoContrato.contrato
        let prePagamento = contratos.filter((contrato) => contrato.tipoContrato === 'Pré-Pagamento')
        let custoOperacional = contratos.filter((contrato) => contrato.tipoContrato === 'Custo Operacional')

        // this.objetoBeneficiario.competencia = this.convertCompetencia(resultadoUnimed.)
        this.objetoBeneficiario.tipoAtualizacao = resultadoUnimed.tipoAtualizacao
          ? resultadoUnimed.tipoAtualizacao.toLocaleUpperCase()
          : 'MANUAL'
        this.objetoBeneficiario.qtAutoGestao = resultadoUnimed.totalAutoGestao
        this.objetoBeneficiario.dataAtualizacao = this.convertDate(resultadoUnimed.dataRequisicao)

        // pré-pagamento
        if (!!prePagamento && prePagamento.length > 0) {
          this.objetoBeneficiario.qtPessoaJuridicaAdesaoPrePagamento = prePagamento[0].coletivoAdesao
          this.objetoBeneficiario.qtPessoaJuridicaPrePagamento = prePagamento[0].coletivoEmpresarial
          this.objetoBeneficiario.qtPessoaFisicaPrePagamento = prePagamento[0].individualFamiliar
        } else {
          this.objetoBeneficiario.qtPessoaJuridicaAdesaoPrePagamento = 0
          this.objetoBeneficiario.qtPessoaJuridicaPrePagamento = 0
          this.objetoBeneficiario.qtPessoaFisicaPrePagamento = 0
        }

        // custo operacional
        if (!!custoOperacional && custoOperacional.length > 0) {
          this.objetoBeneficiario.qtPessoaJuridicaAdesaoCustoOperacional = custoOperacional[0].coletivoAdesao
          this.objetoBeneficiario.qtPessoaJuridicaCustoOperacional = custoOperacional[0].coletivoEmpresarial
          this.objetoBeneficiario.qtPessoaFisicaCustoOperacional = custoOperacional[0].individualFamiliar
        } else {
          this.objetoBeneficiario.qtPessoaJuridicaAdesaoCustoOperacional = 0
          this.objetoBeneficiario.qtPessoaJuridicaCustoOperacional = 0
          this.objetoBeneficiario.qtPessoaFisicaCustoOperacional = 0
        }
      }
    }
  },
  computed: {
    totalBeneficiario() {
      let a = this.objetoBeneficiario.qtPessoaFisicaCustoOperacional * 1 || 0
      let b = this.objetoBeneficiario.qtPessoaFisicaPrePagamento * 1 || 0
      let c = this.objetoBeneficiario.qtPessoaJuridicaCustoOperacional * 1 || 0
      let d = this.objetoBeneficiario.qtPessoaJuridicaPrePagamento * 1 || 0
      let e = this.objetoBeneficiario.qtPessoaJuridicaAdesaoCustoOperacional * 1 || 0
      let f = this.objetoBeneficiario.qtPessoaJuridicaAdesaoPrePagamento * 1 || 0
      let result = (a + b + c + d + e + f) * 1 || 0
      return result
    }
  },
  watch: {
    value() {
      this.valueData = this.value
    },
    valueData() {
      if (!this.valueData) {
        this.$emit('input', false)
        this.showModalCancelar = false
      }
    },
    canEdit() {
      if (this.role === 'admin_brasil') {
        return true
      }
      return false
    }
  }
}
</script>
<style scoped>
.font13 {
  font-size: 13px;
}

.button-cadu {
  margin-top: 20px !important;
  border: 1px solid !important;
}

.btnUpdateCadBenef {
  margin-top: 20px !important;
}
</style>